module.exports = __webpack_public_path__ + "img/chat-favor.3d99bed7.png";